export default __webpack_public_path__ + "static/media/ibuprofen.16fe0ad5.png";